export default "__VITE_ASSET__pR$hFfbr__"